import { Phone } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function FloatingCallSection({ brand, setBrand }) {
  const fc = brand.floating_call || { enabled: true, label: "Zadzwoń teraz" };
  const update = (patch) => setBrand({ ...brand, floating_call: { ...fc, ...patch } });

  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <Phone size={18} className="text-[#dc2626]" /> Pływający przycisk „Zadzwoń teraz”
      </h3>
      <div className="rounded-xl border border-slate-200 p-5 bg-slate-50/50 space-y-4">
        <label className="flex items-center gap-3 p-3 bg-white rounded-lg border border-slate-200">
          <input
            data-testid="floating-call-enabled"
            type="checkbox"
            checked={!!fc.enabled}
            onChange={(e) => update({ enabled: e.target.checked })}
            className="accent-[#dc2626] w-5 h-5"
          />
          <div>
            <div className="font-semibold text-slate-800">Pokaż pływający przycisk na telefonach</div>
            <div className="text-xs text-slate-500">
              Widoczny wyłącznie na telefonach (małe ekrany). Klik odpala aplikację telefonu z numerem z pola „Telefon infolinii”.
              Zwiększa konwersję, bo część klientów woli zadzwonić niż wypełnić formularz.
            </div>
          </div>
        </label>
        <div>
          <label className={labelCls}>Etykieta na przycisku</label>
          <input
            data-testid="floating-call-label"
            className={inputCls}
            value={fc.label || ""}
            onChange={(e) => update({ label: e.target.value })}
            placeholder="Zadzwoń teraz"
          />
          <div className="text-xs text-slate-500 mt-1">
            Wskazówka: krótki tekst (np. „Zadzwoń teraz”, „Zapytaj o ofertę”, „Kontakt”).
          </div>
        </div>
        <div className="text-xs text-slate-600 bg-blue-50 border border-blue-200 rounded-lg p-3">
          Numer telefonu bierze się z pola <strong>„Telefon infolinii”</strong> w zakładce „Marka i kontakt”.
          Aktualny: <span className="font-mono font-bold">{brand?.contact?.phone || "— brak —"}</span>
        </div>
      </div>
    </section>
  );
}
